import { Component } from 'react'
import Board from 'react-trello'

class DraggableBoard extends Component {
  render() {
    const { data, children, customLaneHeader, onDragEnd, onLaneScroll } = this.props
    return (
      <Board
        data={data}
        draggable
        laneDraggable={false}
        customCardLayout={!!children}
        customLaneHeader={customLaneHeader}
        handleDragEnd={(cardId, sourceLaneId, targetLaneId, position, cardDetails) => {
          if (sourceLaneId === targetLaneId) return false
          onDragEnd && onDragEnd(targetLaneId, cardDetails)
        }}
        onLaneScroll={onLaneScroll}
      >
        {children}
      </Board>
    )
  }
}

export default DraggableBoard
